import React, { Component } from 'react'

import { Modal } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'

export default class DeleteUser extends Component<any> {
  state = {
    loading: false,
    show: true,
    password: {
      new: undefined,
      confirm: undefined,
    },
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open)
      this.setState({
        loading: false,
        show: true,
      })
  }

  onModalConfirm = () => {
    this.setState({ loading: true })
    this.props.callback(this.props.open.val).then(isSuccess => {
      isSuccess && this.setState({ loading: false })
    })
  }

  render() {
    return (
      <Modal show={this.state.show && this.props.open.show}>
        <Modal.Header>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {`Are you sure you want to delete this user ?`}
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="danger"
            loading={this.state.loading}
            onClick={this.onModalConfirm}
          >
            {this.state.loading ? 'Please wait' : 'Delete'}
          </Button>
          <Button bsStyle="default" onClick={() => this.setState({ show: false })}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}